<template>
  <div class="user-page page-wrapper">
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">个人中心</h1>
        <p class="page-subtitle">User Center</p>
      </div>
    </div>

    <div class="page-content">
      <div class="container">
        <div class="user-layout">
          <!-- 侧边栏 -->
          <div class="user-sidebar">
            <div class="user-card">
              <div class="user-avatar">
                <el-avatar :size="80" :src="userInfo.avatar" icon="el-icon-user-solid"></el-avatar>
              </div>
              <div class="user-name">{{ userInfo.realname || userInfo.username || '用户' }}</div>
              <div class="user-org">{{ userInfo.organization || '暂无单位信息' }}</div>
            </div>
            <el-menu
              :default-active="activeMenu"
              class="user-menu"
              @select="handleMenuSelect"
            >
              <el-menu-item index="profile">
                <i class="el-icon-user"></i>
                <span>个人信息</span>
              </el-menu-item>
              <!-- <el-menu-item index="registration">
                <i class="el-icon-tickets"></i>
                <span>参会记录</span>
              </el-menu-item> -->
              <el-menu-item index="papers">
                <i class="el-icon-document"></i>
                <span>投稿记录</span>
              </el-menu-item>
            </el-menu>
          </div>

          <!-- 内容区 -->
          <div class="user-content">
            <router-view></router-view>
            <!-- 默认显示个人信息 -->
            <div v-if="$route.path === '/user'" class="default-content">
              <div class="welcome-card">
                <h2>欢迎回来，{{ userInfo.realname || userInfo.username || '用户' }}！</h2>
                <p>您可以在这里管理您的个人信息和投稿记录。</p>
                <div class="welcome-actions">
                  <el-button type="primary" size="medium" icon="el-icon-bank-card" @click="goToPay">
                    立即缴费
                  </el-button>
                </div>
              </div>
              <div class="quick-stats">
                <!-- <div class="stat-item">
                  <div class="stat-icon"><i class="el-icon-tickets"></i></div>
                  <div class="stat-info">
                    <div class="stat-value">{{ stats.registrations }}</div>
                    <div class="stat-label">参会记录</div>
                  </div>
                </div> -->
                <div class="stat-item">
                  <div class="stat-icon"><i class="el-icon-document"></i></div>
                  <div class="stat-info">
                    <div class="stat-value">{{ stats.papers }}</div>
                    <div class="stat-label">投稿记录</div>
                  </div>
                </div>
                <div class="stat-item">
                  <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
                  <div class="stat-info">
                    <div class="stat-value">{{ stats.approved }}</div>
                    <div class="stat-label">已通过摘要</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils'
import { userApi } from '@/api'

export default {
  name: 'User',
  data() {
    return {
      stats: {
        registrations: 0,
        papers: 0,
        approved: 0
      }
    }
  },
  computed: {
    userInfo() {
      return getUserInfo() || {}
    },
    activeMenu() {
      const path = this.$route.path
      if (path.includes('profile')) return 'profile'
      if (path.includes('registration')) return 'registration'
      if (path.includes('papers')) return 'papers'
      return 'profile'
    }
  },
  methods: {
    handleMenuSelect(index) {
      this.$router.push(`/user/${index}`)
    },
    goToPay() {
      this.$router.push('/pay')
    },
    async handleLogout() {
      try {
        await this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        try {
          await userApi.logout()
        } catch (e) {
          // 忽略接口错误
        }
        
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        this.$message.success('已退出登录')
        this.$router.push('/')
      } catch {
        // 用户取消
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-page {
  background: #f8f9fc;
  min-height: 100vh;
}

.user-layout {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.user-sidebar {
  width: 260px;
  flex-shrink: 0;
}

.user-card {
  background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
  border-radius: 16px;
  padding: 30px;
  text-align: center;
  color: #fff;
  margin-bottom: 20px;

  .user-avatar {
    margin-bottom: 16px;
  }

  .user-name {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .user-org {
    font-size: 14px;
    opacity: 0.8;
  }
}

.user-menu {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;

  .el-menu-item {
    height: 56px;
    line-height: 56px;
    font-size: 15px;

    i {
      margin-right: 10px;
      font-size: 18px;
    }

    &.is-active {
      background: linear-gradient(90deg, rgba(26, 35, 126, 0.1), transparent);
      color: #1a237e;
      border-right: 3px solid #1a237e;
    }
  }
}

.sidebar-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .pay-btn {
    width: 100%;
    height: 48px;
    font-size: 16px;
    border-radius: 12px;
    background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
    border: none;

    &:hover {
      background: linear-gradient(135deg, #3949ab 0%, #7c4dff 100%);
    }
  }

  .logout-btn {
    width: 100%;
    height: 44px;
    font-size: 14px;
    border-radius: 12px;
  }
}

.user-content {
  flex: 1;
  min-width: 0;
}

.default-content {
  .welcome-card {
    background: #fff;
    border-radius: 16px;
    padding: 40px;
    margin-bottom: 30px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

    h2 {
      font-size: 24px;
      color: #1a237e;
      margin-bottom: 12px;
    }

    p {
      color: #666;
      font-size: 15px;
      margin-bottom: 20px;
    }

    .welcome-actions {
      .el-button {
        padding: 12px 30px;
      }
    }
  }

  .quick-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  .stat-item {
    background: #fff;
    border-radius: 16px;
    padding: 30px;
    display: flex;
    align-items: center;
    gap: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    transition: all 0.3s;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(26, 35, 126, 0.1);
    }

    .stat-icon {
      width: 60px;
      height: 60px;
      background: linear-gradient(135deg, #1a237e 0%, #7c4dff 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 28px;
        color: #fff;
      }
    }

    .stat-value {
      font-size: 32px;
      font-weight: 700;
      color: #1a237e;
    }

    .stat-label {
      font-size: 14px;
      color: #999;
    }
  }
}

@media screen and (max-width: 992px) {
  .user-layout {
    flex-direction: column;
  }

  .user-sidebar {
    width: 100%;
  }

  .user-menu {
    display: flex;

    .el-menu-item {
      flex: 1;
      text-align: center;
      border-right: none !important;

      &.is-active {
        border-bottom: 3px solid #1a237e;
      }
    }
  }

  .default-content .quick-stats {
    grid-template-columns: 1fr;
  }
}
</style>
